import { Col, Flex, message, Row } from "antd";
import { RuleFormCard } from "./components/RuleFormCard";
import { useMutation } from "@tanstack/react-query";
import { createRule } from "../../../lib/api/resources/rules";
import { useNavigate } from "react-router-dom";
import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";

export const RuleCreate = () => {
  const navigate = useNavigate();

  const createRuleMutation = useMutation({
    mutationFn: async (data: Rule) => createRule(data),
    onSuccess: () => {
      navigate("/rules");
      message.success("Regel succesvol aangemaakt");
    },
    onError: () => {
      message.error("Er is een fout opgetreden bij het aanmaken van de regel");
    },
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <RuleFormCard mutation={createRuleMutation} />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
